import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import { redirectAwayAndAlert } from 'cio/utils/route-access';
import ActionsEmailSuppressionListController from 'cio/pods/actions/email/suppression-list/controller';
import AuthService from 'cio/services/auth';

export default class SuppressionListRoute extends Route {
  @service auth!: AuthService;

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    if (this.auth.redacted) {
      return redirectAwayAndAlert(this, transition);
    }

    return;
  }
  setupController(controller: ActionsEmailSuppressionListController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchMailServers.perform();
  }

  resetController(controller: ActionsEmailSuppressionListController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }
}
